import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader, Card, EmptyState, PageHeader } from "@/components/ui-helpers";
import { StatusBadge } from "@/components/StatusBadge";
import { FileText, ArrowRight } from "lucide-react";

const STATUSES = ["", "Requested", "Uploaded", "Under Review", "Accepted", "Rejected", "Replacement Required", "Expired"];

export default function DocumentsQueue() {
  const [docs, setDocs] = useState(null);
  const [status, setStatus] = useState("");
  useEffect(() => { api.get(`/documents${status ? `?status=${encodeURIComponent(status)}` : ""}`).then((r) => setDocs(r.data)).catch(() => setDocs([])); }, [status]);

  if (!docs) return <Loader />;
  return (
    <div>
      <PageHeader title="Documents" subtitle="Firm-wide document review queue across all cases.">
        <select data-testid="doc-status-filter" value={status} onChange={(e) => setStatus(e.target.value)} className="px-3 py-2 rounded-xl border border-slate-200 bg-white text-sm">
          {STATUSES.map((s) => <option key={s} value={s}>{s || "All statuses"}</option>)}
        </select>
      </PageHeader>
      {docs.length === 0 ? <Card className="p-6"><EmptyState icon={FileText} title="No documents" description="Documents uploaded across cases will appear here." /></Card> : (
        <Card className="overflow-x-auto"><table className="w-full text-sm min-w-[760px]">
          <thead className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wider"><tr><th className="text-left px-5 py-3">Document</th><th className="text-left px-5 py-3">Client</th><th className="text-left px-5 py-3">Case</th><th className="text-left px-5 py-3">Files</th><th className="text-left px-5 py-3">Status</th><th className="px-5 py-3"></th></tr></thead>
          <tbody className="divide-y divide-slate-100">
            {docs.map((x) => (
              <tr key={x.id} data-testid={`docq-${x.id}`} className="hover:bg-slate-50">
                <td className="px-5 py-3 font-semibold text-slate-800">{x.name}{x.required && <span className="ml-1 text-[10px] text-rose-500 font-bold">REQ</span>}</td>
                <td className="px-5 py-3 text-slate-500">{x.client_name}</td>
                <td className="px-5 py-3 text-slate-500">{x.service_type} <span className="font-mono text-xs">{x.app_number}</span></td>
                <td className="px-5 py-3 text-slate-500">{(x.files || []).length}</td>
                <td className="px-5 py-3"><StatusBadge status={x.status} /></td>
                <td className="px-5 py-3 text-right"><Link to={`/admin/applications/${x.application_id}`} className="inline-flex items-center gap-1 text-xs font-semibold text-primary">Open case <ArrowRight className="h-3.5 w-3.5" /></Link></td>
              </tr>
            ))}
          </tbody>
        </table></Card>
      )}
    </div>
  );
}
